var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.btnClass,attrs:{"to":_vm.to}},[_vm._t("default",[_vm._v("This is a btn")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }